import { Certificate } from '~/modules/user/pages/Certificate/blocks/Certificate';

export const CertificatePage = () => {
  return <Certificate />;
};
